<form [formGroup]="form" (ngSubmit)="onSubmit()"
      class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
  @if (!isCheckData) {
    <div class="mt-6 mb-3">
      <h1 class="text-primary">¡Sigue avanzando!</h1>
    </div>
  }

  <div class="w-full space-y-3">
    <app-selected
      class="w-full block"
      [config]="dataSelected().at(0)"
      (selectValue)="handleValue($event)"
    ></app-selected>
    @if (isCheckData && dataLastOnboarding && dataLastOnboarding['hasPublicJobManager'] !== undefined) {
      <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
        <div class="flex items-center gap-2">
          <span class="text-xs text-label">Anterior:</span>
          <span class="font-medium text-base-content">
            {{ (dataLastOnboarding['hasPublicJobManager'] === 1 || dataLastOnboarding['hasPublicJobManager'] === true) ? 'Sí' : 'No' }}
          </span>
        </div>
      </div>
    }
  </div>

  @if (showPublicJobFields) {
    @for (config of publicJobInputs(); track config.formName) {
      <div class="w-full space-y-3">
        <app-input
          class="w-full"
          [config]="config"
          [timeoutSeconds]="1"
          (submitValue)="handleInputValue($event)"
        ></app-input>
        @if (isCheckData && dataLastOnboarding?.[config.formName ?? ''] !== undefined && dataLastOnboarding?.[config.formName ?? ''] !== null && dataLastOnboarding?.[config.formName ?? ''] !== '') {
          <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
            <div class="flex items-center gap-2">
              <span class="text-xs text-label">Anterior:</span>
              <span class="font-medium text-base-content">{{ dataLastOnboarding[config.formName ?? ''] }}</span>
            </div>
          </div>
        }
      </div>
    }
  }

  <div class="w-full space-y-3">
    <app-selected
      class="w-full block"
      [config]="dataSelected().at(1)"
      (selectValue)="handleValue($event)"
    ></app-selected>
    @if (isCheckData && dataLastOnboarding && dataLastOnboarding['isPepRelative'] !== undefined) {
      <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
        <div class="flex items-center gap-2">
          <span class="text-xs text-label">Anterior:</span>
          <span class="font-medium text-base-content">
            {{ (dataLastOnboarding['isPepRelative'] === 1 || dataLastOnboarding['isPepRelative'] === true) ? 'Sí' : 'No' }}
          </span>
        </div>
      </div>
    }
  </div>

  @if (showPepRelativeFields) {
    <div class="w-full space-y-3">
      <app-input
        class="w-full"
        [config]="pepRelativeInputs()[0]"
        [timeoutSeconds]="1"
        (submitValue)="handleInputValue($event)"
      ></app-input>
      @if (isCheckData && dataLastOnboarding?.pepRelativeFullName) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">{{ dataLastOnboarding.pepRelativeFullName }}</span>
          </div>
        </div>
      }
    </div>

    <div class="w-full space-y-3">
      <app-selected
        class="w-full"
        [config]="pepDocumentTypeSelected()"
        (selectValue)="handleValue($event)"
      ></app-selected>
      @if (isCheckData && dataLastOnboarding?.pepRelativeDocumentType !== undefined && dataLastOnboarding?.pepRelativeDocumentType !== null) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">{{ getPepDocumentTypeLabel(dataLastOnboarding.pepRelativeDocumentType) }}</span>
          </div>
        </div>
      }
    </div>

    @for (config of pepRelativeInputs().slice(1); track config.formName) {
      <div class="w-full space-y-3">
        <app-input
          class="w-full"
          [config]="config"
          [timeoutSeconds]="1"
          (submitValue)="handleInputValue($event)"
        ></app-input>
        @if (isCheckData && dataLastOnboarding?.[config.formName ?? ''] !== undefined && dataLastOnboarding?.[config.formName ?? ''] !== null && dataLastOnboarding?.[config.formName ?? ''] !== '') {
          <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
            <div class="flex items-center gap-2">
              <span class="text-xs text-label">Anterior:</span>
              <span class="font-medium text-base-content">{{ dataLastOnboarding[config.formName ?? ''] }}</span>
            </div>
          </div>
        }
      </div>
    }
  }

  @for (config of dataSelected().slice(2, 5); track config.formName) {
    <div class="w-full space-y-3">
      <app-selected
        class="w-full block"
        [config]="config"
        (selectValue)="handleValue($event)"
      ></app-selected>
      @if (isCheckData && dataLastOnboarding && dataLastOnboarding[config.formName ?? ''] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ (dataLastOnboarding[config.formName ?? ''] === 1 || dataLastOnboarding[config.formName ?? ''] === true) ? 'Sí' : 'No' }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  @if (shouldShowCountryField()) {
    <div class="w-full space-y-3">
      <div class="flex flex-col justify-center items-start w-full h-auto relative">
        <div class="flex justify-between items-center w-full pr-2 mb-2">
          <label for="obligatedTaxCountryInput" class="text-label">
            País donde tributa <b class="text-sub-label">*</b>
          </label>
          <app-lock-toggle
            [unlocked]="countryUnlocked()"
            (pressed)="toggleCountryLock()"
          ></app-lock-toggle>
        </div>

        <div class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border bg-white relative"
          [class.border-blue-700]="countryUnlocked()"
          [class.border-gray-300]="!countryUnlocked()">
          <input
            type="text"
            id="obligatedTaxCountryInput"
            [(ngModel)]="inputCountryValue"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Selecciona un país"
            class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
            [ngClass]="{
              'is-invalid': (form.get('obligatedTaxCountryId')?.invalid || form.hasError('invalidCountry'))
                          && (isTimeout || form.get('obligatedTaxCountryId')?.touched)
            }"
            [readonly]="isCheckData || !countryUnlocked()"
            [class.bg-base-200]="isCheckData || !countryUnlocked()"
          />
          @if (isLoadingCountries) {
            <div class="absolute right-3 top-1/2 -translate-y-1/2">
              <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          }
        </div>

        @if (!isCheckData && filteredCountries.length > 0) {
          <div class="absolute w-full top-full left-0 z-50">
            <ul class="w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 max-h-52 overflow-y-auto">
              @for (country of filteredCountries; track country.id) {
                <li
                  class="px-4 py-2 hover:bg-blue-100 cursor-pointer transition-colors duration-150"
                  (click)="selectCountry(country)"
                >
                  {{ country.name }}
                </li>
              }
            </ul>
          </div>
        }

        @if (!isCheckData && (form.get('obligatedTaxCountryId')?.invalid || form.hasError('invalidCountry'))
                && (isTimeout || form.get('obligatedTaxCountryId')?.touched)) {
          <div class="text-red-500 text-[10px] mt-1">
            Por favor selecciona un país válido de la lista
          </div>
        }
      </div>

      @if (isCheckData && dataLastOnboarding?.obligatedTaxCountry) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">País registrado:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding.obligatedTaxCountry }}
            </span>
          </div>
        </div>
      }

      @if (shouldShowTinField()) {
        <div class="flex flex-col justify-center items-start w-full">
          <div class="flex justify-between items-center w-full pr-2 mb-2">
            <label for="tinInput" class="text-label">
              Número de Identificación Tributaria (TIN) <b class="text-sub-label">*</b>
            </label>
            <app-lock-toggle
              [unlocked]="tinUnlocked()"
              (pressed)="toggleTinLock()"
            ></app-lock-toggle>
          </div>

          <div class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border bg-white relative"
            [class.border-blue-700]="tinUnlocked()"
            [class.border-gray-300]="!tinUnlocked()">
            <input
              type="text"
              id="tinInput"
              formControlName="tinNumber"
              [placeholder]="getTinPlaceholder()"
              class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500 text-sm"
              [ngClass]="{
                'is-invalid': form.get('tinNumber')?.invalid && (form.get('tinNumber')?.touched || isTimeout)
              }"
              [readonly]="isCheckData || !tinUnlocked()"
              [class.bg-base-200]="isCheckData || !tinUnlocked()"
            />

            @if (isLoadingFormats) {
              <div class="absolute right-3 top-1/2 -translate-y-1/2">
                <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            }
          </div>

          @if (selectedCountryFormats.length > 0 && !isCheckData) {
            <div class="text-xs text-gray-500 mt-1 space-y-0.5">
              <span class="font-medium">Formatos aceptados:</span>
              @for (format of selectedCountryFormats; track format.id) {
                <div class="flex items-center gap-2">
                  <span class="text-[10px] text-gray-600">- {{ format.description || 'Sin descripción' }}</span>
                </div>
              }
            </div>
          }

          @if (!isCheckData) {
            @if (form.get('tinNumber')?.hasError('invalidTinFormat') && form.get('tinNumber')?.touched) {
              <div class="text-red-500 text-[10px] mt-1">
                {{ form.get('tinNumber')?.getError('invalidTinFormat')?.message || 'Formato TIN inválido' }}
              </div>
            }
            @if (form.hasError('tinRequired') && form.get('tinNumber')?.touched) {
              <div class="text-red-500 text-[10px] mt-1">
                El número de identificación tributaria es obligatorio
              </div>
            }
          }

          @if (isCheckData && dataLastOnboarding?.tinNumber) {
            <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl w-full mt-2">
              <div class="flex items-center gap-2">
                <span class="text-xs text-label">TIN registrado:</span>
                <span class="font-medium text-base-content">
                  {{ dataLastOnboarding.tinNumber }}
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @for (config of dataSelected().slice(5); track config.formName) {
    <div class="w-full space-y-3">
      <app-selected
        class="w-full block"
        [config]="config"
        (selectValue)="handleValue($event)"
      ></app-selected>
      @if (isCheckData && dataLastOnboarding && dataLastOnboarding[config.formName ?? ''] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ (dataLastOnboarding[config.formName ?? ''] === 1 || dataLastOnboarding[config.formName ?? ''] === true) ? 'Sí' : 'No' }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  @if (!isCheckData) {
    <button class="btn-primary mb-6" [disabled]="!canContinue()" type="submit">
      Continuar
    </button>
  }
</form>
